enum SignatureAppearanceDialogFields {
	TEXT = "text",
	SIGNATURE = "signature",
	FILE = "file",
	OPACITY = "opacity",
	POSITION = "position",
}

export default SignatureAppearanceDialogFields;